'use client';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
export const referenceProducts = [
  {
    style: 'Northline coat',
    name: 'Knee-length topcoat',
    category: 'Outerwear',
    role: 'Hero',
    colorway: 'Taupe',
    price: 1650,
  },
  {
    style: 'Fine crew',
    name: 'Fine crewneck',
    category: 'Knitwear',
    role: 'Entry',
    colorway: 'Chalk',
    price: 425,
  },
  {
    style: 'Balance trouser',
    name: 'Pleated straight trouser',
    category: 'Tailoring',
    role: 'Core',
    colorway: 'Ink',
    price: 625,
  },
  {
    style: 'Atelier cardigan',
    name: 'Crew cardigan',
    category: 'Knitwear',
    role: 'Core',
    colorway: 'Oxblood',
    price: 575,
  },
  {
    style: 'Rib funnel',
    name: 'Heavy funnel-neck knit',
    category: 'Knitwear',
    role: 'Core',
    colorway: 'Umber',
    price: 725,
  },
  {
    style: 'Edge jacket',
    name: 'Soft single-breasted jacket',
    category: 'Tailoring',
    role: 'Hero',
    colorway: 'Ink',
    price: 1250,
  },
];
export const ue = {
  name: 'The finished edge',
  line: 'Stock cloths, soft proportions, a thin selvedge-inspired edge line instead of a logo, and Oxblood as the only accent.',
};
export const fe = {
  title: 'LISI\xC8RE FW27 Capsule \u2014 R1 recommendation',
  decision:
    'Build a six-piece wardrobe system around soft, precise tailoring and tactile knits, not runway exaggeration.',
  confidence: 'Medium',
  confidenceWhy:
    'FW27 evidence is forward-looking; runway and trend reports are directional, not LISI\xC8RE demand data.',
  sourceCount: 35,
  sources: [
    {
      publisher: 'Premi\xE8re Vision',
      title: 'AW 26\u201327 Decodings: Fabrics',
      date: 'Sep 2025',
    },
    {
      publisher: 'Pitti Immagine Filati',
      title: 'FW27/28 yarns, 119 companies',
      date: 'Jun 2026',
    },
    {
      publisher: 'WGSN / Coloro',
      title: 'AW27/28 key colours',
      date: 'Jun 2026',
    },
    {
      publisher: 'Heuritech',
      title: 'FW27/28 Trend Edit',
      date: 'May 2026',
    },
    {
      publisher: 'WWD',
      title: 'FW26 buyers focus on knitwear and tailoring',
      date: 'Mar 2026',
    },
    {
      publisher: 'The Woolmark Company',
      title: 'Wool fibre and pilling',
      date: 'Jun 2025',
    },
  ],
  signals: [
    {
      label: 'Silhouette',
      finding:
        'Moderate, city-ready proportion: softly defined shoulder, straight-to-gently-wide trouser.',
    },
    {
      label: 'Fabrics',
      finding:
        'Matte worsted, flannel and double-face wool; reinterpret classic cloths, not novelty materials.',
    },
    {
      label: 'Yarns',
      finding:
        'Subdued classics with moulin\xE9, Donegal, brushed and wool-cashmere textures. One tactile heavy knit.',
    },
    {
      label: 'Colour',
      finding:
        'Forecast leans Russet and Deep Green; keep the brand palette and add Oxblood as the single accent.',
    },
  ],
  gauges: [
    {
      piece: 'Fine crew',
      gauge: '14GG',
      fallback: '12GG',
    },
    {
      piece: 'Atelier cardigan',
      gauge: '12GG',
    },
    {
      piece: 'Rib funnel',
      gauge: '5\u20137GG',
    },
  ],
  leadTimes: [
    {
      item: 'Tailored jackets',
      weeks: '14\u201320',
    },
    {
      item: 'Sweater knitwear',
      weeks: '11\u201318',
    },
  ],
  gates: [
    {
      when: 'Oct 2026',
      step: 'Lock six silhouettes, price architecture, fabric and yarn briefs',
    },
    {
      when: 'Oct\u2013Nov 2026',
      step: 'Contact mills and factories: stock qualities, minimums, lead times',
    },
    {
      when: 'Nov\u2013Dec 2026',
      step: 'Approve handfeel, colour standards, first patterns and knit programs',
    },
    {
      when: 'Jan\u2013Feb 2027',
      step: 'Fit and revise tailoring; approve gauge, shrinkage and pilling tests',
    },
    {
      when: 'Mar 2027',
      step: 'Approve pre-production samples; place material and production orders',
    },
    {
      when: 'Apr\u2013Jun 2027',
      step: 'Bulk production and QC',
    },
    {
      when: 'Jul 2027',
      step: 'Inbound, photography, product data, launch prep',
    },
  ],
  unknowns: [
    'Final fibre compositions',
    'Named mills',
    'Country of origin',
    'MOQ, landed cost and margin',
  ],
};
export const he = {
  idea: 'One curve.',
  line: 'The coat dress as architecture, with construction as the only ornament.',
  steps: [
    {
      key: 'teaser',
      label: 'Teaser',
      shot: 'Back view of the silhouette, space above for type',
    },
    {
      key: 'launch',
      label: 'Launch',
      shot: 'Full-length hero: the curved shoulder-to-waist seam',
    },
    {
      key: 'last-call',
      label: 'Last call',
      shot: 'Hand-finished hem and a covered button',
    },
  ],
  formats: ['4:5 feed', '9:16 Stories', '1:1 feed'],
  checks:
    'Before publishing: add real price, sizes, launch date and stock status; compare seams and buttons against the sample.',
};
export const ge = {
  subject: 'The coat dress. One curve.',
  preheader:
    'FW27, sculpted in double-faced wool. Made in the atelier. Worn for years.',
  blocks: [
    {
      kind: 'wordmark',
      text: 'MAISON AUBRAC',
    },
    {
      kind: 'image',
      asset: 'launch',
    },
    {
      kind: 'headline',
      text: 'The coat dress.',
    },
    {
      kind: 'cta',
      text: 'Shop the coat dress',
    },
    {
      kind: 'section',
      text: 'Finished by hand.',
      asset: 'detail',
    },
    {
      kind: 'links',
      text: 'Boutique \xB7 Shop \xB7 Book a fitting',
    },
  ],
  beforeSending:
    'Host the images, fill the shop and fitting links, confirm atelier claims for this garment.',
};
